module.exports = __webpack_public_path__ + "static/media/17UN-Women4.bd574905.jpg";